import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipFormsCreateModule } from './controllers/MembershipFormsCreateController';
import { FormsDataResolver, MembershipsListDataResolver, MembershipLifecycleActionFormListDataResolver, LoadScriptResolver, LoadCssResolver } from '@b2b/common/resolvers';

export const MembershipFormsCreateView = angular
  .module('acme.view.application.membership.forms.create', [
    uiRouter,
    'ui.bootstrap',
    'isteven-multi-select',
    MembershipFormsCreateModule,
  ])
  .config(function config($stateProvider) {
    const membershipFormsCreate = {
      name: 'application.membership.forms.create',
      url: '/create',
      views: {
        'subview-main@application': {
          templateUrl: 'views/application/views/membership/forms/create/create.tpl.html',
          controller: 'MembershipFormsCreateController',
        },
      },
      data: {
        pageTitle: 'New Membership Form Mapping',
        /** Secure With Permissions **/
        // permissions: ['MEMBERSHIP_RULES_VIEW'],
      },
      resolve: {
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
        MembershipLifecycleActionFormListData: MembershipLifecycleActionFormListDataResolver(),
        FormsListData: FormsDataResolver(),
        MembershipsListData: MembershipsListDataResolver(),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    };

    const membershipFormsEdit = {
      name: 'application.membership.forms.edit',
      url: '/edit/:id',
      views: {
        'subview-main@application': {
          templateUrl: 'views/application/views/membership/forms/create/create.tpl.html',
          controller: 'MembershipFormsCreateController',
        },
      },
      data: {
        pageTitle: 'Edit Membership Form Mapping',
        /** Secure With Permissions **/
        // permissions: ['MEMBERSHIP_RULES_VIEW'],
      },
      resolve: {
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
        MembershipLifecycleActionFormListData: MembershipLifecycleActionFormListDataResolver(),
        FormsListData: FormsDataResolver(),
        MembershipsListData: MembershipsListDataResolver(),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    };

    $stateProvider.state(membershipFormsCreate).state(membershipFormsEdit);
  }).name;
